import { ColDef } from 'ag-grid-community';
import { PrivateBankingServiceDefinitionId, ServiceRole } from 'pco-product-service-internal-consumer';
import { ebankingServiceRoleColumns } from './ebankingServiceRoleColumns';
import { safeDepositBoxServiceRoleColumns } from './safeDepositBoxServiceRoleColumns';

const serviceRoleColumnsByProduct: Partial<Record<PrivateBankingServiceDefinitionId, ColDef<ServiceRole>[]>> = {
  [PrivateBankingServiceDefinitionId.Ebanking]: ebankingServiceRoleColumns,
  [PrivateBankingServiceDefinitionId.SafeDepositBox]: safeDepositBoxServiceRoleColumns,
  [PrivateBankingServiceDefinitionId.DebitMaestrocard]: [],
};

export const getServiceRoleColumns = (
  serviceDefinitionId: PrivateBankingServiceDefinitionId | undefined,
): ColDef<ServiceRole>[] => (serviceDefinitionId && serviceRoleColumnsByProduct[serviceDefinitionId]) ?? [];
